export const getRemoveBackgroundDialogMessage = ({
	removeBackgroundDialog,
	t,
}) => {
	const affectedWidgetsCount = Number(removeBackgroundDialog?.affectedCount || 0);

	return affectedWidgetsCount > 0
		? (
			(t.removeBackgroundDialogMessage
				|| '{count} widgets overlap this background. Remove it and auto-reposition them?')
				.replace('{count}', String(affectedWidgetsCount))
		)
		: (t.removeBackgroundDialogMessageEmpty || 'Remove this background image?');
};
